import { jsx as h } from "react/jsx-runtime";
import { tv as c } from "tailwind-variants";
const e = c({
  base: [
    "border",
    "disabled:bg-neutral-500",
    "disabled:border-neutral-500",
    "flex",
    "font-bold",
    "font-secondary",
    "italic",
    "items-center",
    "justify-center",
    "px-5",
    "py-3",
    "text-center",
    "text-base",
    "tracking-wider",
    "transition-colors",
    "rounded-full",
    "uppercase",
    "w-fit",
    "leading-none"
  ],
  variants: {
    isWide: {
      true: ["px-7"]
    },
    level: {
      primary: [
        "bg-rose-600",
        "border-rose-600",
        "hover:bg-red-700",
        "hover:border-red-700",
        "text-white"
      ],
      secondary: [
        "bg-blue-800",
        "border-blue-800",
        "hover:bg-blue-900",
        "hover:border-blue-900",
        "text-white"
      ],
      tertiary: [
        "bg-white",
        "border-white",
        "hover:bg-neutral-50",
        "hover:border-neutral-50",
        "text-neutral-900"
      ]
    },
    isGhost: {
      true: ["bg-transparent", "border-current", "hover:bg-transparent"]
    }
  },
  compoundVariants: [
    {
      level: "primary",
      isGhost: !0,
      class: ["hover:text-red-700", "text-rose-600"]
    },
    {
      level: "secondary",
      isGhost: !0,
      class: ["hover:text-blue-900", "text-blue-800"]
    },
    {
      level: "tertiary",
      isGhost: !0,
      class: [
        "hover:border-neutral-700",
        "hover:text-neutral-700",
        "text-neutral-900"
      ]
    }
  ]
}), v = ({
  ariaHidden: r,
  ariaLabel: t,
  className: o,
  children: a,
  disabled: s,
  isGhost: l,
  isWide: n,
  level: i = "primary",
  onClick: b,
  tabIndex: d,
  type: u
}) => /* @__PURE__ */ h(
  "button",
  {
    "aria-hidden": r,
    "aria-label": t,
    className: e({ class: o, isGhost: l, isWide: n, level: i }),
    disabled: s,
    onClick: b,
    tabIndex: d,
    type: u,
    children: a
  }
);
v.styles = e;
export {
  v as default
};
